// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user_payment_setting_container{
    padding: var(--space);
}

.user_payment_setting_box{
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    background: var(--white-color);
    margin-bottom: var(--space);
}

.user_payment_setting_box_title_option{
    border-bottom: 1px solid var(--new-gray-background-color);
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.user_payment_setting_box_title{
    margin: var(--space);
}

.user_payment_setting_box_title .baloa-normal-medium{
    color: var(--primary-very-dark-color)
}

.user_payment_setting_box_information{
    padding: var(--space);
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    background: var(--white-color);
    margin: var(--space-half);
}
.user_payments_setting_item{
    display: flex;
    flex-direction: column;
    gap: var(--space-half);
}

.user_payments_setting_item .baloa-table-column{
    color: var(--primary-dark-color);
}

.user_payments_setting_item .baloa-names{
    color:var(--primary-very-dark-color)
}

.user_payments_setting_item .baloa-names.link{
    color:var(--new-green-color)
}

.user_payment_setting_box_item-information{
    display: flex;
    gap: 20%;
}

.user_payment_setting_box_section_item{
    display: flex;
    flex-direction: column;
    gap: var(--space);
}

.user_payment_setting_principal-cards{
    background-color: var( --new-green-color);
    font-size: 13px;
    color: var(--white-color);
    border-radius: 21.3464px;
    padding: 3px 5px;
    margin-left: 10px;
}

.user_payment_setting_box_title_option .user_payment_setting_box_button{
    margin-right: var(--space-half);
}

.user_payment_setting_box_icon{
    display: flex;
    gap: var(--space-half);
    align-items: center;
}

.user_payment_setting_box_icon .hubicon-edit:before{
    color: var(--new-green-color);
}

.user_payment_setting_box_button:hover .hubicon-edit::before{
    color: var(--white-color);
}

.user_payment_setting_box_button:focus .hubicon-edit::before {
    background-color: var(--new-green-color);
    color: var(--white-color);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .user_payment_setting_box_item-information {
        display: flex;
        flex-direction: column;
        gap: 20%;
    }

    .user_payment_setting_box_section_item{
        margin-bottom: var(--space);
    }
}`, "",{"version":3,"sources":["webpack://./src/app/user-settings/components/user-payments-settings/UserPaymentSettingComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;AACzB;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,yDAAyD;IACzD,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kDAAkD;IAClD,kBAAkB;IAClB,8BAA8B;IAC9B,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,yCAAyC;IACzC,eAAe;IACf,yBAAyB;IACzB,wBAAwB;IACxB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,aAAa;QACb,sBAAsB;QACtB,QAAQ;IACZ;;IAEA;QACI,2BAA2B;IAC/B;AACJ","sourcesContent":[".user_payment_setting_container{\n    padding: var(--space);\n}\n\n.user_payment_setting_box{\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    background: var(--white-color);\n    margin-bottom: var(--space);\n}\n\n.user_payment_setting_box_title_option{\n    border-bottom: 1px solid var(--new-gray-background-color);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.user_payment_setting_box_title{\n    margin: var(--space);\n}\n\n.user_payment_setting_box_title .baloa-normal-medium{\n    color: var(--primary-very-dark-color)\n}\n\n.user_payment_setting_box_information{\n    padding: var(--space);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    background: var(--white-color);\n    margin: var(--space-half);\n}\n.user_payments_setting_item{\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-half);\n}\n\n.user_payments_setting_item .baloa-table-column{\n    color: var(--primary-dark-color);\n}\n\n.user_payments_setting_item .baloa-names{\n    color:var(--primary-very-dark-color)\n}\n\n.user_payments_setting_item .baloa-names.link{\n    color:var(--new-green-color)\n}\n\n.user_payment_setting_box_item-information{\n    display: flex;\n    gap: 20%;\n}\n\n.user_payment_setting_box_section_item{\n    display: flex;\n    flex-direction: column;\n    gap: var(--space);\n}\n\n.user_payment_setting_principal-cards{\n    background-color: var( --new-green-color);\n    font-size: 13px;\n    color: var(--white-color);\n    border-radius: 21.3464px;\n    padding: 3px 5px;\n    margin-left: 10px;\n}\n\n.user_payment_setting_box_title_option .user_payment_setting_box_button{\n    margin-right: var(--space-half);\n}\n\n.user_payment_setting_box_icon{\n    display: flex;\n    gap: var(--space-half);\n    align-items: center;\n}\n\n.user_payment_setting_box_icon .hubicon-edit:before{\n    color: var(--new-green-color);\n}\n\n.user_payment_setting_box_button:hover .hubicon-edit::before{\n    color: var(--white-color);\n}\n\n.user_payment_setting_box_button:focus .hubicon-edit::before {\n    background-color: var(--new-green-color);\n    color: var(--white-color);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .user_payment_setting_box_item-information {\n        display: flex;\n        flex-direction: column;\n        gap: 20%;\n    }\n\n    .user_payment_setting_box_section_item{\n        margin-bottom: var(--space);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
